// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"22":"c395b4b8","621":"c3d625dc","753":"51555078","787":"4128ea63","806":"5562ddd8"}[chunkId] + ".chunk.js";
};